//Please add the language resource
const orderModifyLog = {
  schOrderNo:'SchOrderNo',
  customerCode:'CustomerCode',
  businessType: 'BusinessType',
  consigneeCode: 'ConsigneeCode',
  orderCreateTime: 'OrderCreateTime',
  orderUpdateTime:'OrderUpdateTime',
  expectedDeliveryDate:'ExpectedDeliveryDate',
  skuCodes:'SkuCodes',
  consigneeAddrContact:'ConsigneeAddrContact',
  consigneeAddrTel:'ConsigneeAddrTel',
  orderMemo: 'OrderMemo',

  msg:{
  }
};
export default orderModifyLog



// WEBPACK FOOTER //
// ./src/page/report/orderModifyLog/lang/orderModifyLog.en.js